import { FormFieldWrapper } from './FormFieldWrapper';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

// A styled input component, if you pass options, it will render a select component
export const StyledInput = ({ name, label, formData, options, width, ariaLabel, ariaRequired, placeholder }) => {
    return (
        <FormFieldWrapper label={label} width={width}>
            <TextField
                fullWidth
                id={name}
                name={name}
                select={options ? true : false}
                value={formData.values[name]}
                placeholder={placeholder}
                onChange={formData.handleChange}
                onBlur={formData.handleBlur}
                error={formData.touched[name] && Boolean(formData.errors[name])}
                helperText={formData.touched[name] && formData.errors[name]}
                size={"small"}
                inputProps={{
                    'aria-label': ariaLabel,
                    'aria-required': ariaRequired
                }}
                sx={{ 
                    '& .MuiInputBase-input': {
                        backgroundColor: '#FFF',
                    },
                }}
            >
                {options && options.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
        </FormFieldWrapper>
    );
};
